/* Birthday free gifts.
   Two jobs, and they are separate on purpose:

   1. The "What's inside" toggle, which opens the panel (CSS does the animation).
      The tiles in that panel are the INDIVIDUAL gifts, listed so the customer can
      see what is in the box. They are rendered by Liquid and never change here.

   2. The spend tiers, which are not displayed at all. Each tier is a band of order
      totals and a Discount Ninja promotion token. When the cart lands in a band this
      fires that band's token; Discount Ninja is what then puts the bundled gift box
      in the cart and discounts it. Nothing here adds to the cart or changes a price.

   ORDER MATTERS, and rotating-offer.js learned it the hard way: the token must be fired
   BEFORE the item is added, never after. Measured there, same cart both ways:
     add -> trigger :  POST /cart/clear.js @714, POST /cart/add.js @1217  (DN wipes it)
     trigger -> add :  no DN cart calls at all
   So this listens for the add-to-cart INTENT in the capture phase, works out what the
   cart is about to become (current subtotal + the selected variant x its quantity) and
   fires that band's token first. It never blocks the add and never touches the cart. */
(function () {
  'use strict';

  var ADD_FORM = 'form[action*="/cart/add"]';

  var cfgEl = document.getElementById('tsc-bday-gifts-data');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  var TIERS = CFG.tiers || [];

  /* ---------------------------------------------------------------- toggle */

  function bindToggles() {
    document.querySelectorAll('[data-gift-toggle]').forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = '1';
      button.addEventListener('click', function () {
        var panel = button.closest('[data-gift-panel]');
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------- Discount Ninja */

  // Highest band whose range contains the total. max 0 means no ceiling.
  function bandFor(cents) {
    var best = null;
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i];
      if (!t.token || cents < t.min) continue;
      if (t.max > 0 && cents > t.max) continue;
      if (!best || t.min > best.min) best = t;
    }
    return best;
  }

  function dnReady() {
    return typeof discountNinja !== 'undefined' &&
      discountNinja.api && discountNinja.api.promotions &&
      typeof discountNinja.api.promotions.trigger === 'function';
  }

  // DN loads asynchronously, so a token worked out before it is ready is held
  // and fired as soon as it appears rather than dropped.
  var pending = null;
  var waiting = false;
  function trigger(token) {
    if (!token) return;
    if (dnReady()) {
      try { discountNinja.api.promotions.trigger(token); } catch (e) { /* non-critical */ }
      return;
    }
    pending = token;
    if (waiting) return;
    waiting = true;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (dnReady()) {
        clearInterval(timer);
        waiting = false;
        var t = pending; pending = null;
        if (t) { try { discountNinja.api.promotions.trigger(t); } catch (e) {} }
      } else if (tries > 40) {          // ~20s, then give up quietly
        clearInterval(timer);
        waiting = false;
        pending = null;
      }
    }, 500);
  }

  // Only on a change of band, so a steady cart is not re-triggered on every poll.
  var firedToken = null;
  function syncDiscountNinja(cartCents) {
    var band = bandFor(cartCents);
    var token = band ? band.token : '';
    if (token === firedToken) return;
    firedToken = token;
    trigger(token);
  }

  /* ------------------------------------------------------- the gift box */

  /* Discount Ninja grants the box as a NORMALLY PRICED line - $120 / $190 / $210 -
     and only discounts it at checkout, so Shopify's cart counts it in total_price.
     Left in, the box pays for itself into the next band: a $200 cart lands in tier 1,
     the $120 box arrives, the cart now reads $320, that is tier 2, so tier 2's token
     fires, DN swaps the box, the total moves again. The bands oscillate and whichever
     token loses the race can leave no box at all. Take the box back out of the spend. */
  var GIFT_IDS = String(CFG.giftIds || '').split(',')
    .map(function (v) { return parseInt(v, 10); })
    .filter(function (n) { return n > 0; });

  function isGiftLine(item) {
    if (!item) return false;
    if (GIFT_IDS.length) return GIFT_IDS.indexOf(item.product_id) !== -1;
    // Before the ids are configured, fall back to the product title so a fresh
    // install still measures the right number.
    return /gift box/i.test(item.product_title || item.title || '');
  }

  /* The figure DN's offers test against: "total cart value BEFORE discounts", with
     the gift boxes themselves excluded (each offer excludes its own BDAY TIER
     collection). So sum the ORIGINAL line prices of everything that is not a box -
     not total_price, which is after the 30% and would read a tier too low. */
  function spendCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item)) return;
      total += (item.original_line_price != null ? item.original_line_price
                                                 : (item.final_line_price || 0));
    });
    return total > 0 ? total : 0;
  }

  function giftIdFor(band) {
    var i = TIERS.indexOf(band);
    return i > -1 ? (GIFT_IDS[i] || 0) : 0;
  }

  /* ------------------------------------------------ what the order adds up to */

  var cartCents = 0;

  function priceMap() {
    var map = {};
    (CFG.variantPrices || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length === 2) map[bits[0].trim()] = parseInt(bits[1], 10) || 0;
    });
    return map;
  }

  // Several [name="id"] inputs share a product page (main form, Shop Pay, cart
  // upsells); the one that matters is the only one holding a variant of THIS product.
  function selectedCents() {
    var prices = priceMap();
    var inputs = document.querySelectorAll('[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      var v = String(inputs[i].value || '').trim();
      if (!v || !prices[v]) continue;
      var form = inputs[i].closest('form');
      var qEl = form && form.querySelector('[name="quantity"]');
      var q = qEl ? parseInt(qEl.value, 10) : 1;
      if (!q || q < 1) q = 1;
      return prices[v] * q;
    }
    return 0;
  }

  /* ------------------------------------------------ the tier gift on display */

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + v;
  }

  // Below the lowest band Discount Ninja gives nothing at all, so the panel is
  // hidden rather than promising gifts this order will not get.
  function floorCents() {
    var lowest = 0;
    for (var i = 0; i < TIERS.length; i++) {
      if (!TIERS[i].token) continue;
      if (!lowest || TIERS[i].min < lowest) lowest = TIERS[i].min;
    }
    return lowest;
  }

  var lastPaint = null;
  function paintTiers() {
    var list = document.querySelector('[data-gift-list]');
    if (!list) return;
    var tiles = [].slice.call(list.querySelectorAll('[data-tier-min]'));

    var total = cartCents + selectedCents();
    if (total === lastPaint) return;
    lastPaint = total;

    var floor = floorCents();
    var below = floor > 0 && total < floor;
    document.querySelectorAll('.tsc-bday-gifts').forEach(function (w) {
      w.classList.toggle('is-below-floor', below);
    });
    if (below) return;

    // highest band the order falls inside wins; bands are steps, not extras
    var winner = null, winnerMin = -1;
    tiles.forEach(function (t) {
      var min = parseInt(t.getAttribute('data-tier-min'), 10);
      var max = parseInt(t.getAttribute('data-tier-max'), 10);
      if (isNaN(min) || total < min || min <= winnerMin) return;
      if (!isNaN(max) && max > 0 && total > max) return;
      winnerMin = min; winner = t;
    });

    var base = parseInt(list.getAttribute('data-base-count'), 10) || 0;
    var extra = 0;
    tiles.forEach(function (t) {
      var on = t === winner;
      t.classList.toggle('is-pending', !on);
      if (on) extra = parseInt(t.getAttribute('data-tier-value'), 10) || 0;
    });

    // the headline value and the item count follow whatever is actually on show
    var baseVal = parseInt(list.getAttribute('data-base-value'), 10) || 0;
    var totalVal = baseVal + extra;
    document.querySelectorAll('.tsc-bday-gifts__total').forEach(function (el) {
      el.textContent = '(' + money(totalVal) + ' value)';
    });
    document.querySelectorAll('[data-gift-value]').forEach(function (el) {
      el.textContent = money(totalVal);
    });
    document.querySelectorAll('[data-gift-count]').forEach(function (el) {
      el.textContent = base + (winner ? 1 : 0);
    });
  }

  // A product page carries several [name="id"] inputs (main form, Shop Pay, cart
  // upsells), so the one that matters is the one inside the form being submitted.
  function variantCentsFor(form) {
    if (!form) return 0;
    var prices = {};
    (form.getAttribute('data-variant-prices') || CFG.variantPrices || '')
      .split(',').forEach(function (pair) {
        var bits = pair.split(':');
        if (bits.length === 2) prices[bits[0].trim()] = parseInt(bits[1], 10) || 0;
      });
    var input = form.querySelector('[name="id"]');
    if (!input) return 0;
    var cents = prices[String(input.value).trim()] || 0;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    return cents * qty;
  }

  // Capture phase, so this runs before the theme's own submit handler.
  var lastIntentAt = 0;
  function onAddIntent(e) {
    var form = e.target && e.target.closest ? e.target.closest(ADD_FORM) : null;
    if (!form) return;
    lastIntentAt = Date.now();
    syncDiscountNinja(cartCents + variantCentsFor(form));
    afterAddCheck();
  }

  /* Firing the token here is still a race we lose more often than not: trigger()
     is asynchronous and the theme POSTs /cart/add.js in the same tick, so the add
     arrives before DN has armed the promotion and no box is granted. Measured on a
     tier 2 saber, the box was still absent 10s later.

     So take one corrective shot once the dust settles. Read the cart twice a short
     way apart; only act if it looks SETTLED (same total both times) and the box for
     the band is genuinely missing. The band is taken from the real cart, never from
     cart-plus-selection, so this can only ever ask for the box the cart has actually
     earned - it cannot talk DN out of a good one. */
  /* Discount Ninja's tier offers REPEAT per threshold multiple. Tier 1's threshold is
     $100, so a $231 cart gets floor(231/100) = 2 boxes. Measured: $112 -> 1 box,
     $231 -> 2 boxes. Tier 2 and 3 cannot reach a second multiple inside their own
     ceilings, so it shows up as "tier 1 sometimes gives two".

     The real fix is in the DN offer (grant a fixed quantity of 1, not one per
     threshold). This is the safety net, and it holds: clamping the line back to 1
     sticks, DN does not re-add the second, and the box stays free. Also drops any
     box from a band the cart is no longer in, which is the same bug after a band
     change. */
  var clamps = 0;
  var MAX_CLAMPS = 6;

  function tidyGiftLines(cart, want) {
    if (clamps >= MAX_CLAMPS) return false;
    var gifts = (cart.items || []).filter(isGiftLine);
    if (!gifts.length) return false;

    var jobs = [];
    gifts.forEach(function (item) {
      var keep = want ? item.product_id === want : (jobs.length === 0 && item === gifts[0]);
      if (!keep) jobs.push({ key: item.key, quantity: 0 });       // wrong band's box
      else if (item.quantity > 1) jobs.push({ key: item.key, quantity: 1 });
    });
    // never strip the last box if none of them matches the band - let the trigger fix it
    if (want && !gifts.some(function (i) { return i.product_id === want; })) return false;
    if (!jobs.length) return false;

    clamps++;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    jobs.reduce(function (chain, job) {
      return chain.then(function () {
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: job.key, quantity: job.quantity })
        });
      });
    }, Promise.resolve()).then(function () { scheduleRecheck(); }).catch(function () {});
    return true;
  }

  /* A duplicated gift box is ALWAYS wrong and is safe to fix the instant it is seen.
     Unlike firing a token, clamping a quantity does not fight DN's rebuild - verified
     that DN does not re-add the one we take away - so this deliberately skips the
     quiet gate that reconcileGift() needs. Waiting for the cart to settle first was
     what left two boxes on screen for ~4s. */
  function clampDuplicateGifts(cart) {
    if (clamps >= MAX_CLAMPS) return false;
    var dupes = (cart.items || []).filter(function (item) {
      return isGiftLine(item) && item.quantity > 1;
    });
    if (!dupes.length) return false;

    clamps++;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    dupes.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 1 })
        });
      });
    }, Promise.resolve()).then(function () {
      document.dispatchEvent(new CustomEvent('la:dn:cart:updated'));   // repaint the drawer
      scheduleRecheck();
    }).catch(function () {});
    return true;
  }

  var afterAddTimer = null;
  function afterAddCheck(attempt) {
    attempt = attempt || 0;
    if (attempt > 5) return;                 // ~13s of looking, then leave it to reconcile
    clearTimeout(afterAddTimer);
    afterAddTimer = setTimeout(function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var read = function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; });
      };
      read().then(function (first) {
        if (!first) return;
        return new Promise(function (res) { setTimeout(res, 400); }).then(read).then(function (cart) {
          if (!cart || !first) return;
          // Still churning - DN is mid-rebuild. Look again rather than giving up:
          // the one-shot version kept landing inside this window and never acted.
          if (cart.total_price !== first.total_price) { afterAddCheck(attempt + 1); return; }
          var spend = spendCents(cart);
          var band = bandFor(spend);
          if (!band || !band.token) return;
          var want = giftIdFor(band);
          if (tidyGiftLines(cart, want)) { afterAddCheck(attempt + 1); return; }
          var has = (cart.items || []).filter(isGiftLine)
            .map(function (i) { return i.product_id; });
          if (want ? has.indexOf(want) !== -1 : has.length) return;
          cartCents = spend;
          lastTriggerAt = Date.now();
          firedToken = null;
          trigger(band.token);
        });
      }).catch(function () {});
    }, 3000);
  }

  /* ------------------------------------------- make sure the box arrived */

  /* Firing the token is a request, not a guarantee. It gets lost when DN is still
     booting, when DN clears and rebuilds the cart around the add, or when the band
     is reached by a route that never fires one at all - a quantity change in the
     drawer, a removed line, or simply arriving with a qualifying cart already in
     the session. syncDiscountNinja() also refuses to repeat a token it has already
     sent, so once a grant is lost nothing asks for it a second time.

     So: after every cart read, check the box that should be there actually is, and
     if not, ask again. Bounded - a few attempts per band per page view - so a band
     DN genuinely disagrees with cannot turn into a loop. */

  /* The guard that matters is QUIET. Discount Ninja clears the cart and rebuilds it
     around every write, and for those ~2.8s the box is genuinely gone. Read that as
     "missing" and you ask again, which makes DN clear again - a loop that ends with
     no box at all. So only ever ask when the cart has been STILL for a while, and
     never twice in quick succession. Every cart write counts, not just add-to-cart:
     DN's own churn, a quantity change in the drawer, a removed line. */
  var QUIET_MS = 3500;       // cart must be untouched this long before we judge it
  var COOLDOWN_MS = 8000;    // and this long since we last asked
  var RECHECK_MS = 2500;
  var MAX_FIXES = 2;         // per band
  var MAX_FIXES_TOTAL = 3;   // per page view
  var fixes = {};
  var fixesTotal = 0;
  var recheckTimer = null;
  var lastCartChangeAt = Date.now();
  var lastTriggerAt = 0;
  var cartPrint = null;

  // Any change to the cart's contents restarts the quiet window.
  function noteCartState(cart) {
    var print = (cart.item_count || 0) + ':' + (cart.total_price || 0) + ':' +
      (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',');
    if (print !== cartPrint) {
      cartPrint = print;
      lastCartChangeAt = Date.now();
    }
  }

  function scheduleRecheck() {
    clearTimeout(recheckTimer);
    recheckTimer = setTimeout(refresh, RECHECK_MS);
  }

  function reconcileGift(cart) {
    var band = bandFor(cartCents);
    if (!band || !band.token) return;

    var want = giftIdFor(band);
    var present = (cart.items || []).filter(isGiftLine)
      .map(function (item) { return item.product_id; });
    var ok = want ? present.indexOf(want) !== -1 : present.length > 0;

    if (ok) {
      fixes[band.token] = 0;
      var messy = (cart.items || []).filter(isGiftLine).some(function (i) {
        return i.quantity > 1 || (want && i.product_id !== want);
      });
      if (!messy) return;
      if (Date.now() - lastCartChangeAt >= QUIET_MS) tidyGiftLines(cart, want);
      else scheduleRecheck();          // not quiet yet - come back, do not drop it
      return;
    }

    var now = Date.now();
    // Mid-write, mid-churn, or we only just asked: look again later, stay quiet now.
    if (now - lastIntentAt < QUIET_MS ||
        now - lastCartChangeAt < QUIET_MS ||
        now - lastTriggerAt < COOLDOWN_MS) { scheduleRecheck(); return; }

    var tried = fixes[band.token] || 0;
    if (tried >= MAX_FIXES || fixesTotal >= MAX_FIXES_TOTAL) return;
    fixes[band.token] = tried + 1;
    fixesTotal++;
    lastTriggerAt = now;

    firedToken = null;         // let the same token be sent again
    trigger(band.token);
    scheduleRecheck();
  }

  /* ------------------------------------------- repaint the cart after DN */

  /* Discount Ninja adds the gift box straight to the cart, but the drawer the
     customer is looking at is a point-in-time render and knows nothing about it,
     so the box only appeared after a manual reload.

     This repaints from the server the way the theme itself does. Two traps,
     both learned in rotating-offer.js:

     1. NEVER swap #shopify-section-cart-drawer. That replaces the <cart-drawer>
        element and the replacement comes back CLOSED, slamming an open drawer
        shut and stranding body.overflow-hidden. The theme's own
        getSectionsToRender() targets #CartDrawer INSIDE it, so do the same -
        safe whether the drawer is open or closed.
     2. DN clears the cart before rebuilding it. A snapshot taken inside that
        window renders an empty drawer, so if the markup says is-empty while the
        cart really has lines, take another. */

  var SNAPSHOT_TRIES = 4;
  var SNAPSHOT_RETRY_MS = 250;

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function fetchCartSections() {
    var u = new URL(window.location.href.split('#')[0]);
    u.searchParams.set('sections', 'cart-icon-bubble,cart-drawer');
    u.searchParams.set('sections_url', window.location.pathname);
    return fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function repaintCart(tries) {
    tries = tries || 0;
    return fetchCartSections().then(function (map) {
      if (!map) return;
      var drawerHtml = map['cart-drawer'];
      if (drawerHtml && /is-empty/.test(drawerHtml) && tries < SNAPSHOT_TRIES) {
        return new Promise(function (res) { setTimeout(res, SNAPSHOT_RETRY_MS); })
          .then(function () { return repaintCart(tries + 1); });
      }
      if (drawerHtml) {
        var inner = sectionInner(drawerHtml, '#CartDrawer');
        var mount = document.querySelector('#CartDrawer');
        if (inner !== null && mount) mount.innerHTML = inner;
      }
      var bubbleHtml = map['cart-icon-bubble'];
      if (bubbleHtml) {
        var bMount = document.getElementById('cart-icon-bubble');
        if (bMount) {
          var bInner = sectionInner(bubbleHtml, '#shopify-section-cart-icon-bubble');
          bMount.innerHTML = bInner !== null ? bInner : bubbleHtml;
        }
      }
    }).catch(function () {});
  }

  /* ------------------------------------------------------------ cart watch */

  function refresh() {
    if (!TIERS.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        // Discount Ninja measures its gift tiers on the spend AFTER its own discount
        // (minimumSpendMode: "after"), so use the same basis or the tile shown here
        // and the box DN actually grants disagree. total_price is the cart after all
        // discounts, excluding shipping and tax - and spendCents() takes the gift
        // box itself back out of it.
        noteCartState(cart);
        // before anything else - the customer should never see two boxes
        clampDuplicateGifts(cart);
        // spendCents() mirrors exactly what DN's offers measure: the cart BEFORE
        // discounts, with the gift boxes excluded.
        cartCents = spendCents(cart);
        lastPaint = null;
        paintTiers();
        reconcileGift(cart);
        // Deliberately does NOT trigger here. Firing after a cart write is the
        // ordering that makes DN clear and rebuild the cart.
      })
      .catch(function () {});
  }

  function start() {
    bindToggles();
    refresh();
    paintTiers();
    setInterval(paintTiers, 500);

    document.addEventListener('submit', onAddIntent, true);
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[name="add"], [type="submit"]') : null;
      if (btn) onAddIntent({ target: btn });
    }, true);

    if (typeof window.subscribe === 'function') {
      ['cart-update', 'cart-drawer-update', 'quantity-update'].forEach(function (event) {
        try { window.subscribe(event, refresh); } catch (e) {}
      });
    }

    // app-driven carts (Discount Ninja, upsells) don't publish, so watch the cart
    // count bubble and the drawer for changes instead
    var bubble = document.querySelector('#cart-icon-bubble, .cart-count-bubble, cart-drawer');
    if (bubble && window.MutationObserver) {
      var queued;
      new MutationObserver(function () {
        clearTimeout(queued);
        queued = setTimeout(refresh, 400);
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (event) {
      document.addEventListener(event, refresh);
    });
    // DN has just finished changing the cart: re-read it for the band, and
    // repaint the drawer so the gift box is visible without a reload.
    var repaintQueued;
    document.addEventListener('la:dn:cart:updated', function () {
      refresh();
      clearTimeout(repaintQueued);
      repaintQueued = setTimeout(function () { repaintCart(); }, 80);
    });
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
